import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './count-card.scss';
import AdvancePopover from '../advance-popover/advance-popover';
import BesicTable from '../table/basicTable';
import '../table/table.scss';
import { ArrowCircleDownIcon } from '../icons/icons';

/**
 * @typedef {'left' | 'center' | 'right'} AlignType - Size choices for the Demo component.
 */

/**
 * Component to demonstrate different sizes, appearances, and popup options.
 * @param {Object} props
 * @param {AlignType} props.align
 * @returns {JSX.Element}
 */

export default function CountIcon({
  data,
  label,
  onClick,
  columns,
  disableBorder,
  disableHover,
  align,
  disableClick,
  enableIcon,
  icon,
  popoverPlacement,
  className,
  disableBorderOnHover,
  // showIcon,
}) {
  const alignProperties = {
    left: 'left',
    center: 'center',
    right: 'right',
  };
  const alignProps = alignProperties[align];
  const [eventValue, setEventValue] = useState();
  const [showIcon, setShowIcon] = useState(false);

  const togglePopover = (e) => {
    if (!disableClick) {
      setEventValue(e.target);
    }
    onClick();
  };
  const handleClose = () => {
    setEventValue(null);
  };

  return (
    <div
      className={`count-card-container icon${` ${alignProps}`} ${className}`}
    >
      <button
        className={`count-card${disableBorder ? ' disable-border' : ''}${
          disableBorderOnHover ? '-hover' : ''
        }${disableHover ? ' disable-hover' : ''}`}
        type="button"
        onClick={togglePopover}
        onMouseEnter={() => {
          setShowIcon(true);
        }}
        onMouseLeave={() => {
          setShowIcon(false);
        }}
        id="countPopover"
      >
        <span>{label || icon}</span>
        {disableBorder && enableIcon && showIcon && (
          <ArrowCircleDownIcon className="arrow-icon" />
        )}
      </button>
      {data && data.length > 0 && (
        <AdvancePopover
          reference="countPopover"
          getEvent={eventValue}
          closePopover={handleClose}
          placement={popoverPlacement}
        >
          <div className="count-card-table custom-table-container">
            <BesicTable
              data={data}
              columns={columns}
              className="auto-column-width"
            />
          </div>
        </AdvancePopover>
      )}
    </div>
  );
}
CountIcon.propTypes = {
  data: PropTypes.arrayOf(Object),
  columns: PropTypes.arrayOf(Object),
  label: PropTypes.string,
  onClick: PropTypes.func,
  disableBorder: PropTypes.bool,
  disableHover: PropTypes.bool,
  align: PropTypes.string,
  disableClick: PropTypes.bool,
  enableIcon: PropTypes.bool,
  icon: PropTypes.element,
  popoverPlacement: PropTypes.string,
  className: PropTypes.string,
  disableBorderOnHover: PropTypes.bool,
};
CountIcon.defaultProps = {
  data: [],
  columns: [],
  label: '',
  onClick: () => {},
  disableBorder: false,
  disableHover: false,
  align: 'left',
  disableClick: false,
  enableIcon: false,
  icon: {},
  popoverPlacement: 'center',
  className: '',
  disableBorderOnHover: false,
};
